var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-code-mirror": "" } },
    [
      _c("codemirror-editor", {
        ref: "cm-wrapper",
        attrs: { options: _vm.editorOptions, value: _vm.value },
        on: { change: _vm.onChange, input: _vm.onInput },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }